import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './EditTenantEmailBanner.scss';
import { MediaPickerButton } from 'components';
import { Button } from 'design-system-web';
import { getLibraryOptions } from 'lane-shared/helpers';

type EditTenantEmailBannerProps = {
  channel: { _id?: string } | undefined;
  initialVisitorEmailBannerId: string | null | undefined;
  onSave: (visitorEmailBannerId: string | null) => void;
  onCancel: () => void;
};

export const EditTenantEmailBanner = ({
  channel,
  initialVisitorEmailBannerId,
  onSave,
  onCancel,
}: EditTenantEmailBannerProps) => {
  const { t } = useTranslation();
  const [selectedBannerId, setSelectedBannerId] = useState<string | null>(
    initialVisitorEmailBannerId ?? null
  );

  const handleSave = () => {
    onSave(selectedBannerId);
  };

  return (
    <div className={styles.Editor} data-test="tenant-email-banner-editor">
      <div className={styles.PickerContainer}>
        <MediaPickerButton
          libraries={getLibraryOptions({ channel })}
          media={{ _id: selectedBannerId ?? '' }}
          storageKey={`tenantEmailBanner_${channel?._id}`}
          onMediaSelected={media => {
            setSelectedBannerId(media?._id ?? null);
          }}
          emptyText={t(
            'web.admin.channel.settings.tenantManagement.tenant.details.tenantEmailBannerSection.backgroundLabel'
          )}
          testId="tenant-email-banner-picker"
        />
        <p className={styles.HelperText}>
          {t(
            'web.admin.channel.settings.tenantManagement.tenant.details.tenantEmailBannerSection.backgroundHelpText'
          )}
        </p>
      </div>
      <div className={styles.ButtonGroup}>
        <Button
          variant="primary"
          size="large"
          testId="save-tenant-email-banner"
          onClick={handleSave}
        >
          {t(
            'web.admin.channel.settings.tenantManagement.tenant.details.tenantEmailBannerSection.save'
          )}
        </Button>
        <Button
          variant="secondary"
          size="large"
          testId="cancel-tenant-email-banner"
          onClick={onCancel}
        >
          {t(
            'web.admin.channel.settings.tenantManagement.tenant.details.tenantEmailBannerSection.cancel'
          )}
        </Button>
      </div>
    </div>
  );
};
